
export default {
  name: 'CircularsList',

  fetchOnServer: false,
  data() {
    return {
      circulars: [],
    }
  },
  async fetch() {
    let circulars = await fetch(`${this.$config.apiSfUrl}/circulars?$expand=resources&$orderby=CircularDate desc&sf_culture=${this.$i18n.locale}`).then((res) => res.json())
    this.circulars = circulars.value
  },
}
